import { Component, Input, OnInit } from '@angular/core';
import { ExcelService } from 'src/app/services/excel.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent implements OnInit {
  constructor(public _excel:ExcelService) {}

  ngOnInit(): void {}
}
